import { Injectable } from '@angular/core';
import { CommonService } from '@app/core/services';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { EMPTY, switchMap, tap } from 'rxjs';
import { GetEmailNotificationSettings, GetReplyToCCAddresses, Preview, ResetEmailNotificationSettings, SaveEmailNotificationSettings, UpdateThemeColor } from './common.action';
import { EmailNotificationSetting, ReplyToCCAddress } from '@app/core/models/common';

export class CommonStateInfo {
  primaryColor: string;
  exported?: boolean;
  replyToCCAddresses: ReplyToCCAddress[];
  emailNotificationSettings: EmailNotificationSetting[];
}

@State<CommonStateInfo>({
  name: 'common',
  defaults: {
    primaryColor: '',
    replyToCCAddresses: [],
    emailNotificationSettings: [],
  },
})
@Injectable()
export class CommonState {
  constructor(public commonService: CommonService) {}

  @Selector()
  static getReplyToCCAddresses(state: CommonStateInfo): ReplyToCCAddress[] {
    return state.replyToCCAddresses;
  }

  @Selector()
  static getEmailNotificationSettings(state: CommonStateInfo): EmailNotificationSetting[] {
    return state.emailNotificationSettings;
  }

  @Action(GetReplyToCCAddresses)
  getReplyToCCAddresses({ patchState }: StateContext<CommonStateInfo>) {
    return this.commonService.getReplyToCCAddresses().pipe(
      tap((res) => {
        if (res.isSuccess) {
          patchState({ replyToCCAddresses: res.valueResult });
        }
      })
    );
  }

  @Action(GetEmailNotificationSettings)
  getEmailNotificationSettings({ patchState }: StateContext<CommonStateInfo>) {
    return this.commonService.getEmailNotificationSettings().pipe(
      tap((res) => {
        if (res.isSuccess) {
          patchState({ emailNotificationSettings: res.valueResult });
        }
      })
    );
  }

  @Action(SaveEmailNotificationSettings)
  saveEmailNotificationSettings(_ctx: StateContext<CommonStateInfo>, action: SaveEmailNotificationSettings) {
    return this.commonService.saveEmailNotificationSettings(action.payload);
  }

  @Action(ResetEmailNotificationSettings)
  resetEmailNotificationSettings(_ctx: StateContext<CommonStateInfo>, action: ResetEmailNotificationSettings) {
    return this.commonService.resetEmailNotificationSettings(action.moduleId);
  }

  @Action(Preview)
  preview({ patchState }: StateContext<CommonStateInfo>, action: Preview) {
    return this.commonService.export(action.exportParams, action.moduleId).pipe(
      switchMap((res) => {
        patchState({ exported: true });

        return EMPTY;
      })
    );
  }

  @Action(UpdateThemeColor)
  updateThemeColor(
    { getState, patchState }: StateContext<CommonStateInfo>,
    action: UpdateThemeColor
  ) {
    return this.commonService.updateThemeColor(action.colorCode).pipe(
      tap((res) => {
        patchState({
          primaryColor: res,
        });
      })
    );
  }
}
